import BrandLockup from './BrandLockup';
import ExternalLink from './ExternalLink';
import { externalLinks } from '../config/links';

export default function Header() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a className="site-header__brand" href="#top" aria-label="ShareShutter, back to top">
          <BrandLockup size={28} />
        </a>

        <ExternalLink
          className="button button--primary button--compact"
          href={externalLinks.console}
          newTabHint
        >
          Open Console
        </ExternalLink>
      </div>
    </header>
  );
}
